import { useTranslation } from 'react-i18next'
import { Spinner } from '@rentflowdev/ui'
import { useListDealHistoryQuery } from '@/api'
import { DEFAULT_LOCALE } from '@/types'

interface DealHistorySectionProps {
	dealId: string
}

function formatDateTime(iso: string): string {
	return new Date(iso).toLocaleString(DEFAULT_LOCALE, {
		day:    '2-digit',
		month:  '2-digit',
		year:   '2-digit',
		hour:   '2-digit',
		minute: '2-digit',
	})
}

export function DealHistorySection({ dealId }: DealHistorySectionProps) {
	const { t } = useTranslation()
	const { data, isLoading } = useListDealHistoryQuery({ dealId })

	const items = data?.items ?? []

	if (isLoading) {
		return <Spinner size="sm" />
	}

	if (items.length === 0) {
		return (
			<p className="text-sm text-(--color-muted-foreground)">{t('deals.history.empty')}</p>
		)
	}

	return (
		<div className="flex flex-col">
			{items.map((entry) => (
				<div
					key={entry.id}
					className="flex items-start gap-3 border-b border-(--color-border) py-3 last:border-b-0"
				>
					<div className="mt-1 size-2 shrink-0 rounded-full bg-(--color-brand)" />
					<div className="flex flex-1 min-w-0 flex-col gap-0.5">
						<p className="text-sm text-(--color-foreground)">
							{entry.actionLabel ?? entry.action}
						</p>
						<span className="text-xs text-(--color-muted-foreground)">
							{entry.actorName ? `${entry.actorName} • ` : ''}{formatDateTime(entry.createdAt)}
						</span>
					</div>
				</div>
			))}
		</div>
	)
}
